export const apiMethods = {
  post: 'POST',
  get: 'GET',
  put: 'PUT',
  delete: 'DELETE'
};

export type APIMethodsType = 'POST' | 'GET' | 'PUT' | 'DELETE';

export const API_LOADING = 'API_LOADING';

export const statusTexts = {
  verified: 'VERIFIED',
  pending: 'PENDING',
  inProcess: 'IN_PROCESS',
  failed: 'FAILED'
};
